import { BaseExportModal } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { useMemo } from 'react'
import { ATTRIBUTION_CODES_COLUMNS } from 'features/tradespend/attributionCodesColumnInfo'
import { useDownload } from 'features/download-widget'
import { exportAttributionCodes } from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

interface AttributionCodeExportModalProps {
  show: boolean
  _handleClose: () => void
  filters: Record<string, unknown>
  offerId: number
}

export default function AttributionCodeExportModal(
  props: AttributionCodeExportModalProps
) {
  const { startDownload } = useDownload()
  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )

  const codeColumnHelper = createExportColumnHelper({
    columns: ATTRIBUTION_CODES_COLUMNS,
  })

  const columns = useMemo(() => {
    return [
      {
        title: 'Code Information',
        elements: [
          codeColumnHelper.retrieveColumn('name'),
          codeColumnHelper.retrieveColumn('description'),
          codeColumnHelper.retrieveColumn('code'),
        ],
      },
      {
        title: 'Usage Information',
        elements: [
          codeColumnHelper.retrieveColumn('view_count'),
          codeColumnHelper.retrieveColumn('emails_captured'),
          codeColumnHelper.retrieveColumn('click_count'),
          codeColumnHelper.retrieveColumn('ctr'),
          codeColumnHelper.retrieveColumn('total_enrollments'),
          codeColumnHelper.retrieveColumn('total_claims'),
          codeColumnHelper.retrieveColumn('pending_claims'),
          codeColumnHelper.retrieveColumn('invalid_claims'),
          codeColumnHelper.retrieveColumn('paid_claims'),
          codeColumnHelper.retrieveColumn('unpaid_valid_claims'),
          codeColumnHelper.retrieveColumn('total_validated_units'),
          codeColumnHelper.retrieveColumn('total_validated_payout'),
        ],
      },
      {
        title: 'Metadata',
        elements: [
          codeColumnHelper.retrieveColumn('created_by'),
          codeColumnHelper.retrieveColumn('created'),
          codeColumnHelper.retrieveColumn('modified'),
        ],
      },
    ]
  }, [])

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting Attribution Codes...' }],
      initiate: async (signal) => {
        const result = await exportAttributionCodes(
          props.offerId,
          { selected_columns: selectedCols, export_type: exportType },
          props.filters,
          signal
        )
        return { type: 'blob', blob: result.blob, filename: result.filename }
      },
      label: 'attribution codes',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for Attribution Codes Download"
      subTitle="Download up to 10,000 attribution codes at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Attribution Codes"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
